import React from "react";

import "./index.scss"; // Assurez-vous que le chemin est correct
export const AvantagesSection = ({ avantages, description }) => {
  return (
    <section className="avantages-section text-center py-5">
      <h2 className="section-title">Avantages</h2>
      <p className="section-subtitle">{description}</p>
      <div className="container mt-4">
        <div className="row justify-content-center mt-5">
          {avantages.map((item, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3 mb-4">
              <div className="avantage-card p-4">
                <div className="icon mb-3">{item.icon}</div>
                <p className="avantage-text mb-0">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
